<template>
  <div class="header">
    <h1 v-html="$t('unbounce.poster.headline')" />
    <p v-if="paragraph" v-html="paragraph" />
    <slot name="paragraph" />
    <join-us-button class="button" />
    <img src="/img/unbounce/arrow.gif" />
    <slot />
  </div>
</template>

<script>
import JoinUsButton from '@/components/common/JoinUsButton.vue';

export default {
  props: {
    paragraph: String,
  },
  components: {
    JoinUsButton,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/views/ab/common.scss';

.header {
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 1150px;
  width: 100vw;
  background: black;
  overflow: hidden;
  background: rgba(58, 101, 240, 0.8);
  background: -webkit-linear-gradient(
      rgba(58, 101, 240, 0.8),
      rgba(58, 101, 240, 0.8)
    ),
    url('~@/assets/icons/m1.jpg') no-repeat;
  background-position: center;
  background-size: 100% auto;
}

h1,
p {
  font-family: $ab-font-montserrat;
}

h1 {
  color: white;
  text-align: center;
  font-size: 82px;
  padding-top: 50px;
}

p {
  padding-top: 35px;
  padding-bottom: 15px;
  color: white;
}

img {
  padding-bottom: 15px;
}
</style>
